/**
 *
 * EmptySvg
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { iconPerformance } from "./svg"

const list = {
  iconPerformance: {
    svg: iconPerformance,
  },
}

const renderActions = (actions) => {
  if (!actions) {
    return null
  }

  return <div className="hz-empty__actions">{actions}</div>
}

const renderTitle = (title) => {
  if (!title) {
    return null
  }

  return <div className="hz-empty__title">{title}</div>
}

const renderSubTitle = (subtitle) => {
  if (!subtitle) {
    return null
  }

  return <div className="hz-empty__subtitle">{subtitle}</div>
}

const EmptySvg = ({ svg, title, subtitle, className, actions }) => (
  <div className={`hz-empty ${className || ""}`}>
    <div className="hz-empty__image">{list[svg || "notResults"].svg()}</div>
    {renderTitle(title || list[svg || "notResults"].title)}
    {renderSubTitle(subtitle || list[svg || "notResults"].subtitle)}
    {renderActions(actions)}
  </div>
)

EmptySvg.propTypes = {
  svg: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  actions: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.object,
    PropTypes.func,
  ]),
}

export default EmptySvg
